import { Icon, Loader, Menu, Popup } from '@mairistem/composants';
import { request } from '@mairistem/tools';
import React from 'react';
import { toast } from 'react-toastify';

import { ARRETES } from '@/constants';
import { getDocumentTemporaryUrl } from '@/routes';
import type { DocumentType } from '@/types';

interface ArretesJournaliersDocumentPopupProps {
  documents?: DocumentType[];
}

const ArretesJournaliersDocumentPopup = (props: ArretesJournaliersDocumentPopupProps) => {
  const { documents } = props;
  const [downloading, setDownloading] = React.useState(false);

  const documentProduitMr = React.useMemo(
    () => documents?.find((d) => d.categorie === ARRETES.CATEGORIE_RECAPITULATIF_MR_JR),
    [documents],
  );
  const documentParRecu = React.useMemo(
    () => documents?.find((d) => d.categorie === ARRETES.CATEGORIE_RECAPITULATIF_PAR_RECU),
    [documents],
  );

  const handleDownload = React.useCallback(async (document: DocumentType) => {
    setDownloading(true);
    try {
      const { url }: { url: string } = await request.get(
        getDocumentTemporaryUrl(document.identifiant),
      );
      window.open(url, '_blank');
    } catch {
      toast.error("Erreur lors de l'ouverture du document");
    } finally {
      setDownloading(false);
    }
  }, []);

  const renderItem = (label: string, document?: DocumentType) => (
    <Menu.Item
      onClick={document ? () => handleDownload(document) : undefined}
      title={!document ? 'Génération en cours' : undefined}
      style={!document ? { fontStyle: 'italic' } : undefined}
    >
      <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
        {document ? <Icon name="file pdf" fitted /> : <Loader size="mini" active inline />}
        {label}
      </span>
    </Menu.Item>
  );

  return (
    <Popup
      style={{ padding: 0 }}
      trigger={
        downloading ? (
          <Loader size="mini" active inline />
        ) : (
          <Icon name="file pdf" size="large" link fitted />
        )
      }
      position="bottom right"
      flowing
      on="click"
      content={
        <Menu vertical fluid borderless>
          {renderItem(
            'Récapitulatif des encaissements par produit et mode de règlement',
            documentProduitMr,
          )}
          {renderItem('Récapitulatif des encaissements par reçu', documentParRecu)}
        </Menu>
      }
    />
  );
};

export default ArretesJournaliersDocumentPopup;
